"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMachinesSummary = getMachinesSummary;
async function getMachinesSummary(advertisingRepo) {
    return advertisingRepo.getMachinesSummary();
}
